import { useState, useEffect } from "react";
import Modal from "../Modal";
import { useTranslation } from "react-i18next";
import { getAxiosInstance } from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Button, FormControl, FormLabel, Input, Spacer, Text } from "@chakra-ui/react";
import { TbTrash } from "react-icons/tb";
import { getPlaceOfBusinessIconByType } from "../../utils/invetory";
import { Select } from "chakra-react-select";
import { PLACE_OF_BUSSINESS_TYPE } from "../../utils/types.global";


interface NewCompaniesModalProps {
    isOpen: boolean;
    onClose: () => void;
}

type Business = {
    name: string,
    address: string,
    type: number
}

const ModalCompanies = (props: NewCompaniesModalProps) => {
    const [company, setCompany] = useState({});
    const { t } = useTranslation("translations");
    const [businessInput, setBusinessInput] = useState<Business[]>([]);


    const setUpCompanyObject = (value: string, name: string) => {
        setCompany({ ...company, [name]: value });
    }

    const setUpBusinessArray = (index: number, name: string, value: any) => {
        let arr = [...businessInput];

        switch (name) {
            case "name":
                arr[index]["name"] = value;
                break;
            case "address":
                arr[index]["address"] = value;
                break;
            case "type":
                arr[index]["type"] = value;
                break;
            default:
        }

        setBusinessInput(arr);
    }

    const addCompany = async () => {
        try {
            await getAxiosInstance().post('/companies', { ...company, placeOfBusiness: businessInput });
            toast.success(t("PROVIDER_ADDED_SUCCESFULLY"), { position: toast.POSITION.BOTTOM_RIGHT });
            setCompany({});
            props.onClose();
        } catch (error) {
            toast.error(t("SOMENTHING_WENT_WRONG"), { position: toast.POSITION.BOTTOM_RIGHT });
        }

    }

    const addBusinessInputs = () => {
        setBusinessInput([...businessInput, { name: "", address: "", type: 0}])
    }

    const removeBusiness = (index: number) => {
        let arr = [...businessInput];
        arr.splice(index, 1);
        setBusinessInput(arr);
    }

    useEffect(() => {
        setBusinessInput([]);
    }, [props.onClose])

    return (
        <Modal
            header={t("Add Company")}
            isOpen={props.isOpen}
            onClose={props.onClose}
            secondaryActionName={t("Save")}
            secondaryActionEnabled={true}
            secondaryAction={() => addCompany()}
        >
            <div className="space-y-2">
                <FormControl>
                    <FormLabel>{t("Name")}</FormLabel>
                    <Input name='name' onChange={(e) => { setUpCompanyObject(e.target.value, e.target.name) }} placeholder='ex: SC. - SRL' />
                    <Text className="flex mt-2" fontSize='lg' as="b">  {t("Places of Business")} </Text>
                    <Accordion>
                        {
                            businessInput?.map((n: any, index: number) => {
                                return (
                                    <AccordionItem>
                                        <AccordionButton>
                                            <Button
                                                onClick={() => removeBusiness(index)}
                                                colorScheme="red"
                                                mr="2"
                                            >
                                                <TbTrash />
                                            </Button>
                                            {getPlaceOfBusinessIconByType(n.type)}
                                            {n.name.length > 0 ? n.name : t("NEW_PALCE_OF_BUSINEES")}
                                            <Spacer />
                                            <AccordionIcon />
                                        </AccordionButton>
                                        <AccordionPanel>
                                            <div className={!n.isDeleted ? "block" : "none"} key={index}>
                                                <FormLabel>{t("TYPE")}</FormLabel>
                                                <Select
                                                    className="z-99"
                                                    name='type'
                                                    isRequired
                                                    options={
                                                        Object.keys(PLACE_OF_BUSSINESS_TYPE)
                                                            .filter((v) => isNaN(Number(v)))
                                                            .map((x, index) => ({ value: index, label: t(x), color: "yellow" }))
                                                    }
                                                    value={{ value: n.type, label: t(PLACE_OF_BUSSINESS_TYPE[n.type]), color: "yellow" }}
                                                    tagVariant="solid"
                                                    placeholder={t("SELECT_A_PALCE_OF_BUSINESS")}
                                                    onChange={(e) => setUpBusinessArray(index, 'type', e?.value)}
                                                />                                           <div className="mt-3 ">
                                                    <FormLabel>{t("Name")}</FormLabel>
                                                    <Input
                                                        isRequired
                                                        name='name'
                                                        onChange={(e) => { setUpBusinessArray(index, e.target.name, e.target.value) }}
                                                        value={n.name}
                                                        placeholder='ex: Suceava'
                                                    />
                                                    <FormLabel>{t("Address")}</FormLabel>
                                                    <Input
                                                        name='address'
                                                        onChange={(e) => { setUpBusinessArray(index, e.target.name, e.target.value) }}
                                                        value={n.address}
                                                        placeholder='ex: Str. Pincipală Nr. 3'
                                                    />
                                                </div>
                                            </div>
                                        </AccordionPanel>
                                    </AccordionItem>
                                )
                            })
                        }
                    </Accordion>
                    <Button className="mt-2" onClick={(e) => addBusinessInputs()}> {t("Add Place of Business")}</Button>
                </FormControl>
            </div>
        </Modal>
    )
}

export default ModalCompanies;